import { Component, Input, OnInit, Output, EventEmitter, Optional } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { TextInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { WarningInputInduxtryDirective } from 'src/app/shared/directives/warning-input-induxtry/warning-input-induxtry.directive';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from '../../miscelanea/tooltip/tooltip.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
@Component({
  selector: 'password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PasswordInputComponent,
    },
  ],
  standalone: true,
  imports: [CommonModule, 
      TooltipComponent, 
      MatIconModule, 
      MatInputModule, 
      WarningInputInduxtryDirective, 
      MatFormFieldModule, 
      FormsModule
    ]
})
export class PasswordInputComponent implements OnInit, ControlValueAccessor {
  warningIconPasswordInput = returnWarningIcon;
  colorWarningPasswordInput = returnColorWarning;
  textWarningPasswordInput = returnTextWarning;

  @Input() passwordInput: TextInput;

  @Input() warning: Warning;

  @Output() valueEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Input() formControlName: string;

  hide = true;

  constructor(@Optional() private controlContainer: ControlContainer) { }


  writeValue(value: any): void {
    this.passwordInput.value = value;
  }

  onChange: (_: any) => void = () => { }

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    if(this.controlContainer) {
      const control = this.controlContainer.control.get(this.formControlName);
      if (control && control.hasValidator(Validators.required)) {
        this.passwordInput.required.active = true;
      }
    }
  }

  setValue() {
    this.onChange(this.passwordInput.value);
    this.valueEmitter.emit(this.passwordInput.value);
  }
}
